import { HardHatIcon } from './HardHatIcon';

/**
 * author: Michael Richins
 * id C0F69308-03DA-446D-9B7F-A5B2B5BF1D90
 * name hard-hat
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hard-hat.svg
 * tags
 * - Hardware / Tools 
 * - Clothing 
 */
export const HelmetIcon = HardHatIcon;
export default HelmetIcon